import { Organization, User } from 'src/shared/types/user';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type AuthState = {
  user: User | null;
  authToken: string | null;
  newToken: string | null;
  fallBackToken: string | null;
  selectedOrganization: Organization | null;
  impersonation?: string | null;
  isLoading: boolean;
};

type AuthActions = {
  setAuthToken: (authToken: string | null) => void;
  setFallBackToken: (authToken: string | null) => void;
  setNewToken: (authToken: string | null) => void;
  setUser: (user: any) => void;
  setSelectedOrganization: (organization: Organization | null) => void;
  logout: () => void;
  setImpersonation: (impersonation: string | null) => void;
  setIsLoading: (isLoading: boolean) => void;
};

const initialState: AuthState = {
  user: null,
  authToken: null,
  selectedOrganization: null,
  fallBackToken: null,
  newToken: null,
  impersonation: null,
  isLoading: false
};

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set) => ({
      ...initialState,
      logout: () => {
        set(initialState);
        localStorage.clear();
      },
      setAuthToken: (authToken) => {
        if (authToken) {
          localStorage.setItem('authToken', authToken);
        } else {
          localStorage.removeItem('authToken');
        }

        return set({ authToken });
      },
      setFallBackToken: (fallBackToken) => set({ fallBackToken }),
      setNewToken: (newToken) => set({ newToken }),
      setSelectedOrganization: (selectedOrganization: Organization | null) => {
        if (selectedOrganization) {
          localStorage.setItem(
            'selectedOrganization',
            JSON.stringify(selectedOrganization)
          );
        } else {
          localStorage.removeItem('selectedOrganization');
        }

        return set({ selectedOrganization });
      },
      setUser: (user) => set({ user }),
      setImpersonation: (impersonation) => set({ impersonation }),
      setIsLoading: (isLoading) => set({ isLoading })
    }),
    {
      name: 'session',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
